<template>
  <LISAChip
    v-if="showEisenhowerPriority === true"
    :color="getEisenhowerColor(eisenhowerPriority)"
    style="gap: 0"
    class="mr-1 chipStyleEAB"
    :class="[
      getEisenhowerClass(eisenhowerPriority),
      disabled === false ? 'lisaui:cursor-pointer' : 'cursor-default',
    ]"
    @click="handleClick"
  >
    <i :class="getEisenhowerIconClass(eisenhowerPriority)"></i>
    <span class="text-truncate ml-1">{{
      t(`components.eventAction.filter.badges.PriorityFilter.${eisenhowerPriority}`)
    }}</span>
  </LISAChip>
  <EisenhowerMatrixModal
    v-if="showEisenhowerModal"
    v-model="showEisenhowerModal"
    v-model:priority="eisenhowerPriority"
    :event-prefix="eventPrefix"
    :event="event"
  />
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";
import { type PropType, ref } from "vue";
import EisenhowerMatrixModal from "./EisenhowerMatrixModal.vue";
import { LISAChip } from "@fi-solutions/lisa-ui";
import { useSQDCGlobalSettings } from "@/modules/sqdc/helper/useSQDCGlobalSettings";
import {
  getEisenhowerClass,
  getEisenhowerColor,
  getEisenhowerIconClass,
} from "@/components/event-action/event/EventHelper";
const showEisenhowerModal = ref(false);

const props = defineProps({
  event: {
    type: Object as PropType<{
      id: number;
      typeId: number;
    }>,
    required: false,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showChip: {
    type: Boolean,
    required: false,
    default: false,
  },
  eventPrefix: {
    type: String,
    required: false,
    default: undefined,
  },
});
const emit = defineEmits<{
  click: [event: MouseEvent];
}>();

function handleClick(event: MouseEvent) {
  emit("click", event);

  if (props.disabled === false) {
    showEisenhowerModal.value = true;
  }
}

enum EisenhowerPriority {
  DELEGATE = "DELEGATE",
  DELETE = "DELETE",
  DO = "DO",
  NO_PRIORITY = "NO_PRIORITY",
  SCHEDULE = "SCHEDULE",
}

const eisenhowerPriority = defineModel({
  type: String as PropType<EisenhowerPriority>,
  default: undefined,
});

const { showEisenhowerPriority } = useSQDCGlobalSettings();

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.inputStyle {
  padding: var(--p-multiselect-padding-y) var(--p-multiselect-padding-x) !important;
  border: 1px solid var(--p-multiselect-border-color) !important;
  border-radius: var(--p-border-radius-md) !important;
}
.inputStyle:hover {
  cursor: pointer;
}
.chipStyleEAB {
  font-size: 0.855em !important;
  padding: 0.5em !important;
  line-height: 1 !important;
  font-weight: normal !important;
}
</style>
